import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import SelectFieldContent from '@wix/da-ds/pkg/Dropdown/select/SelectField/SelectFieldContent';
import { getPromptStrength } from '../../../../redux/form/selectors';
import { changePromptStrength } from '../../../../redux/form/actions';
import PanelInputField from '../PanelInputField';
import LabelText from '../LabelText';
const items = Array.from(Array(21).keys()).map((_, index)=>({
        label: index,
        value: index
    }));
const PromptStrengthSelectField = ()=>{
    const { t } = useTranslation('dreamup');
    const strength = useSelector(getPromptStrength);
    const dispatchChangePromptStrength = useAction(changePromptStrength);
    const handleChange = useCallback((value)=>{
        dispatchChangePromptStrength(parseInt(value));
    }, [
        dispatchChangePromptStrength
    ]);
    return /*#__PURE__*/ React.createElement(PanelInputField, {
        rootTag: "label",
        htmlFor: "promptStrength",
        label: /*#__PURE__*/ React.createElement(LabelText, null, t('dreamup.header.settingsPanel.promptStrength.label')),
        input: /*#__PURE__*/ React.createElement(SelectFieldContent, {
            id: "prompt-strength-select",
            name: "promptStrength",
            onSelect: handleChange,
            items: items,
            value: strength,
            withBlankOption: false
        })
    });
};
PromptStrengthSelectField.displayName = 'PromptStrengthSelectField';
export default PromptStrengthSelectField;

//# sourceMappingURL=PromptStrengthSelectField.js.map